import { CircularProgress } from '@nextiva/next-ui-components';

import { LoadingLayout } from './GenericSpinner.styles';

/**
 * GenericSpinner component
 */
const GenericSpinner = () => (
  <LoadingLayout>
    <CircularProgress
      aria-label="progressbar-label"
      data-testid="BillingLicensing-GenericSpinner"
    />
  </LoadingLayout>
);
export default GenericSpinner;
